import { Alert, Box, Paper, Switch, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAnnotationAgentStep } from './useAnnotationAgentStep';
import { PromptBuilder } from '../AnnotationAgent/PromptBuilder';

// TODO: cleanup with cp_annotation_createproject_agent ff

const HEADING_ID = 'annotation-agent-heading';
const TOGGLE_DESCRIPTION_ID = 'annotation-agent-toggle-description';

interface AnnotationAgentStepProps {
  setRequiredFieldsFilled: (fieldsFilled: boolean) => void;
}

export const AnnotationAgentStep = ({ setRequiredFieldsFilled }: AnnotationAgentStepProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const {
    isAgentEnabled,
    isSwitchDisabled,
    unavailableMessageId,
    handleAgentToggle,
    modelId,
    modelOptions,
    handleModelChange,
  } = useAnnotationAgentStep({ setRequiredFieldsFilled });

  return (
    <Box id="annotation-agent-step">
      <Paper
        sx={{
          py: theme.spacing(6),
          px: theme.spacing(7),
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(5),
        }}
      >
        <Box id="annotation-agent-toggle-section">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: theme.spacing(4),
            }}
          >
            <Typography variant="h6" id={HEADING_ID}>
              {formatMessage({ id: 'createProjectWizard.step.annotationAgent.heading' })}
            </Typography>
            {/* The switch has no visible label; the step heading names it. */}
            <Switch
              id="annotation-agent-toggle"
              checked={isAgentEnabled}
              disabled={isSwitchDisabled}
              onChange={(_event, checked) => handleAgentToggle(checked)}
              inputProps={{
                role: 'switch',
                'aria-labelledby': HEADING_ID,
                'aria-describedby': TOGGLE_DESCRIPTION_ID,
              }}
            />
          </Box>
          <Typography
            id={TOGGLE_DESCRIPTION_ID}
            variant="body2"
            sx={{ color: theme.palette.text.secondary }}
          >
            {formatMessage({ id: 'createProjectWizard.step.annotationAgent.toggle.description' })}
          </Typography>
        </Box>
        {unavailableMessageId && (
          <Alert severity="info" id="annotation-agent-unavailable-alert">
            {formatMessage({ id: unavailableMessageId })}
            {isAgentEnabled &&
              ` ${formatMessage({
                id: 'createProjectWizard.step.annotationAgent.unavailable.canTurnOff',
              })}`}
          </Alert>
        )}
        {isAgentEnabled && (
          <PromptBuilder
            modelId={modelId}
            modelOptions={modelOptions}
            onModelChange={handleModelChange}
          />
        )}
      </Paper>
    </Box>
  );
};
